import { render, staticRenderFns } from "./ECardNotification.vue?vue&type=template&id=6cf5911d&scoped=true"
import script from "./ECardNotification.vue?vue&type=script&lang=js"
export * from "./ECardNotification.vue?vue&type=script&lang=js"
import style0 from "./ECardNotification.vue?vue&type=style&index=0&id=6cf5911d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf5911d",
  null
  
)

export default component.exports